/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptGlobalZipTargeting } from '../models/V3StackAdaptGlobalZipTargeting';
import { HttpFile } from '../http/http';

/**
* Geo targeting configuration for StackAdapt campaign
*/
export class V3StackAdaptGeoTargeting {
    /**
    * List of location IDs for geo targeting
    */
    'locationIds'?: Array<string>;
    /**
    * List of location exclusion IDs for geo targeting
    */
    'locationExclusionIds'?: Array<string>;
    /**
    * List of global zip targeting configurations
    */
    'globalZipTargeting'?: Array<V3StackAdaptGlobalZipTargeting>;
    /**
    * List of political districts for geo targeting
    */
    'politicalDistricts'?: Array<string>;
    /**
    * Whether to include DMA in geo targeting
    */
    'includeDma'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "locationIds",
            "baseName": "locationIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "locationExclusionIds",
            "baseName": "locationExclusionIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "globalZipTargeting",
            "baseName": "globalZipTargeting",
            "type": "Array<V3StackAdaptGlobalZipTargeting>",
            "format": ""
        },
        {
            "name": "politicalDistricts",
            "baseName": "politicalDistricts",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "includeDma",
            "baseName": "includeDma",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptGeoTargeting.attributeTypeMap;
    }

    public constructor() {
    }
}

